export const fr = {
    GENERAL_DELETE: 'Effacer',
    GENERAL_CANCEL: 'Susprendre',
    GENERAL_SAVE: 'Sauvegarder',
    GENERAL_SETTINGS: 'Paramètres',
    JSON_EDITOR_REVISION_ACTIVE: 'actif',
    JSON_EDITOR_REVISION_DELETE_CONFIRM: 'Vraiment supprimer la révision?',
    JSON_EDITOR_REVISION_SAVE_SUCCESS: 'Révision enregistrée',
    JSON_EDITOR_REVISION_SAVE_FAILURE: "La révision n'a pas été sauvegardée",
    JSON_EDITOR_REVISION_DELETE_SUCCESS: 'Révision supprimée',
    JSON_EDITOR_REVISION_DELETE_FAILURE: "La révision n'a pas été supprimée",
    JSON_EDITOR_ACTIVE_REVISION_CANT_BE_DELETED: 'Les révisions actives ne peuvent pas être enregistrées',
    JSON_EDITOR_REVISION_ACTIVATE_SUCCESS: 'Révision activée',
    JSON_EDITOR_REVISION_ACTIVATE_FAILURE: "La révision n'a pas été activée",
    JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION: 'Impossible de changer la révision déjà approuvée',
    JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS: "Impossible de changer la révision d'autres administrateurs",
    JSON_EDITOR_INVALID_JSON: 'JSON invalide',
    MISSING_APPROVAL_PERMISSION: "Vous n'avez pas la permission d'approuver les révisions.",
    DIRECTIVE_PHONE_PRESET_CONFIGURE_GLOBAL: 'Configurer le téléphone prédéfini globalement?',
    DIRECTIVE_CHECK_BEFORE_EXPORT_ENABLED: "Les rapports doivent être vérifiés avant l'exportation vers l'intégration",
    DIRECTIVE_EXPORT_SETTINGS_CONFIGURE_GLOBAL: 'Configurer les préférences globalement?',
    DIRECTIVE_APP_CRM_CONNECTION_DISABLED: "Désactiver la connexion CRM dans l'appli Scanner pour cartes de visite",
    DIRECTIVE_EXPORT_SETTINGS_DIRECT_EXPORT: "Transférer les adresses directement à l'extension sélectionnée (CRM).",
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_CONFIGURE_GLOBAL: "Configurer l'exportation automatique globalement?",
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_ENABLED: "Activer l'exportation automatique",
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_TIMEOUT: "Exécuter une exportation automatique après quelques minutes d'inactivité",
    DIRECTIVE_SELECT_INTEGRATION_CHOOSE: "Paramètres d'intégration",
    DIRECTIVE_SELECT_INTEGRATION_CRM_HEADER: 'Systèmes CRM',
    DIRECTIVE_SELECT_INTEGRATION_EMAIL_HEADER: "Intégrations d'e-mail :",
    DIRECTIVE_SELECT_INTEGRATION_MA_HEADER: 'Systèmes de marketing automation :',
    DIRECTIVE_SELECT_INTEGRATION_OTHER_HEADER: 'Autres intégrations :',
    DIRECTIVE_VISITREPORT_MANDATORY_CONFIGURE_GLOBAL: 'Configurer les champs de contact obligatoires globalement?',
    INTEGRATION_MODAL_SNAPADDY_API_HEADER: "Paramètres de l'API snapAddy",
    INTEGRATION_MODAL_SNAPADDY_API_ENDPOINT_URL: "Entrer l'URL",
    INTEGRATION_MODAL_SNAPADDY_API_HTTP_METHOD: 'Méthode HTTP',
    INTEGRATION_MODAL_SNAPADDY_API_AUTH_HEADER: 'Autorisation-En-tête',
    INTEGRATION_MODAL_WECLAPP_HEADER: 'Paramètres Weclapp',
    INTEGRATION_MODAL_SUGAR_HEADER: 'Paramètres SugarCRM',
    INTEGRATION_MODAL_SUITE_HEADER: 'Paramètres SuiteCRM',
    INTEGRATION_MODAL_SUGAR_USE_V41: "J'utilise le Sugar Community Edition",
    INTEGRATION_MODAL_CENTRALSTATION_HEADER: 'ParamètresCentralStationCRM',
    INTEGRATION_MODAL_SAPC4C_HEADER: 'Paramètres SAP Sales Cloud',
    INTEGRATION_MODAL_SAGE_HEADER: 'Paramètres Sage CRM',
    INTEGRATION_MODAL_DYNAMICS_HEADER: 'Paramètres Microsoft Dynamics',
    INTEGRATION_MODAL_ZAPIER_HEADER: 'Paramètres Zapier',
    INTEGRATION_MODAL_SUITE_EXPORT_2: 'CRM Export 2.0 activé',
    INTEGRATION_MODAL_SUITE_PLAINTEXT_PASSWORD: 'Envoyer le mot de passe en texte clair (Le mot de passe ne sera pas enregistré)',
    INTEGRATION_MODAL_GENERIC_ENDPOINT_URL: "Entrer l'URL",
    INTEGRATION_MODAL_OPTIVO_HEADER: 'Paramètres Episerver Campaign',
    INTEGRATION_MODAL_OPTIVO_AUTHTOKEN: "Code d'autorisation",
    INTEGRATION_MODAL_OPTIVO_AUTO_EXPORT: 'Envoyer automatiquement des rapports à Episerver Campaign après vérification',
    INTEGRATION_MODAL_OPTIVO_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/episerver-campaign-authorization-code-and-mailingid',
    INTEGRATION_MODAL_MANDRILL_HEADER: 'Paramètres Mandrill/MailChimp',
    INTEGRATION_MODAL_MANDRILL_API_KEY: 'Clé API',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_TEMPLATE: 'Nom du modèle par défaut',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_EMAIL: "Email de l'expéditeur par défaut",
    INTEGRATION_MODAL_MANDRILL_DEFAULT_NAME: "Nom d'expéditeur par défaut",
    INTEGRATION_MODAL_MANDRILL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/mandrill-api-key-and-template-name',
    INTEGRATION_MODAL_RAPID_MAIL_HEADER: 'Paramètres RapidMail',
    INTEGRATION_MODAL_RAPID_MAIL_USER_NAME: "Nom d'utilisateur de l'API",
    INTEGRATION_MODAL_RAPID_MAIL_PASSWORD: 'Mot de passe API',
    INTEGRATION_MODAL_RAPID_MAIL_INVALID_CREDENTIALS: "Veuillez entrer des informations d'identification d'utilisateur de l'API RapidMail valides.",
    INTEGRATION_MODAL_RAPID_MAIL_AUTO_EXPORT: 'Envoi automatique de rapports à RapidMail après vérification',
    INTEGRATION_MODAL_RAPID_MAIL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/rapidmail-api-user-api-password-and-recipient-list-id',
    INTEGRATION_MODAL_HUBSPOT_HEADER: 'Paramètres Hubspot',
    INTEGRATION_MODAL_HUBSPOT_API_KEY: 'API Key',
    INTEGRATION_MODAL_HUBSPOT_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/hubspot-access-token',
    INTEGRATION_MODAL_SET_DEFAULT_CRM: 'Définir CRM par défaut',
    INTEGRATION_MODAL_SALESFORCE_HEADER: 'Paramètres Salesforce',
    INTEGRATION_MODAL_CLOSEIO_HEADER: 'Paramètres Close.io',
    INTEGRATION_MODAL_OUTLOOK_HEADER: 'Paramètres Outlook',
    REMOVE_SETTINGS_REQUEST: 'Voulez-vous supprimer les paramètres de manière permanente?',
    INT_DYNAMICS_OAUTH_LOGIN: 'Se connecter à OAuth',
    INT_DYNAMICS_OAUTH_LOGIN_RESTRICTION: '(Uniquement pour Dynamics CRM 365 Online)',
    INT_DYNAMICS_USE_API: "Utiliser l'exportation API",
    INT_DYNAMICS_USE_LINK: "Utiliser l'exportation d'URL (sans contrôle des doublons)",
    INT_DYNAMICS_WEB_SESSION: 'Utiliser une session Web existante',
    INT_DYNAMICS_WINDOWS: 'Utiliser le login Windows',
    INT_SAP_LOGIN_TYPE: 'Type de connexion',
    INT_SAP_OAUTH_CLIENT_ID: 'OAuth Client ID',
    INT_SAP_OAUTH_CLIENT_SECRET: 'OAuth Client Secret',
    INT_SAP_USE_WEBSESSION: 'Utiliser une session Web existante',
    INT_SAP_USE_OAUTH: 'OAuth 2.0 via SAML Bearer Assertion',
    INT_SAP_ENTITY_ID: 'Entity ID',
    INTEGRATION_MODAL_GENERIC_PLEASE_CHOOSE: 'Veuillez choisir ...',
    Salutation: 'Salutation',
    Title: 'Titre',
    Vorname: 'Nom',
    Nachname: 'Nom de famille',
    Firma: 'Entreprise',
    Funktion: 'Position',
    Straße: 'Rue',
    Adresszusatz: 'Adresse Ligne 2',
    PLZ: 'Zip',
    Ort: 'Ville',
    Telefon: 'Téléphone',
    Mobile: 'Mobile',
    Fax: 'Fax',
    'E-Mail': 'E-Mail',
    Website: 'Site Internet',
    Land: 'Pays',
    Bundesland: 'État fédéral',
    Kontaktdaten: 'Détails du contact',
};
